export default __webpack_public_path__ + "images/P1.1e4a5dd.png";